import { render, staticRenderFns } from "./buku_penerimaan.vue?vue&type=template&id=5ac52e46&"
import script from "./buku_penerimaan.vue?vue&type=script&lang=js&"
export * from "./buku_penerimaan.vue?vue&type=script&lang=js&"
import style0 from "./buku_penerimaan.vue?vue&type=style&index=0&id=5ac52e46&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports